export enum AttachmentReferenceSource {
	FollowUpStudy = "FOLLOW_UP_STUDY",
	IntakeQuestion = "INTAKE_QUESTION",
}
